import useSWR, { BareFetcher, SWRConfiguration, SWRResponse } from 'swr';
import useSWRImmutable from 'swr/immutable';

interface UseRemoteDataOptions {
  key: string;
  skip?: boolean;
}

const defaultConfig = {
  revalidateOnMount: true,
  revalidateIfStale: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  keepPreviousData: true
};

export const immutableConfig = {
  keepPreviousData: true
};

export const useRemoteData = <O extends UseRemoteDataOptions, T>(
  { key, skip, ...o }: O,
  callback: (o: Omit<O, keyof UseRemoteDataOptions>) => Promise<T>,
  config: SWRConfiguration<T, Error, BareFetcher<T>> = defaultConfig
): SWRResponse<T, Error> => {
  return useSWR<T>(!skip ? { key, ...o } : null, callback, { ...defaultConfig, ...config });
};

export const useImmutableData = <O extends UseRemoteDataOptions, T>(
  { key, skip, ...o }: O,
  callback: (o: Omit<O, keyof UseRemoteDataOptions>) => Promise<T>,
  config: SWRConfiguration<T, Error, BareFetcher<T>> = defaultConfig
): SWRResponse<T, Error> => {
  return useSWRImmutable<T>(!skip ? { key, ...o } : null, callback, { ...immutableConfig, ...config });
};
